<div class="tables-container">
<table *ngIf="bp" class="table table-sm table-dark no-bottom-margin" [ngClass]="{ 'bp-print-view': printView}">
	<tbody>
		<tr bpHl="Aufnahme" [hldata]="bp" class="tborder lborder rborder">
			<th>Punktart</th>
			<td><wd-comment-indicator [fields]="['PunktartMitProtokoll', 'Punktart']" class="cell-text">{{ typName() }}</wd-comment-indicator></td>
			<th>Datum</th>
			<td><wd-comment-indicator [fields]="['Aufnahmedatum']" class="cell-text">{{canSeePersonalData() ? formatDate(bp.header.aufnahme.datum) : '–'}}</wd-comment-indicator></td>
		</tr>
		<tr bpHl="Aufnahme" [hldata]="bp" class="lborder rborder">
			<th>Nummer</th>
			<td><wd-comment-indicator [fields]="['Nummer']" class="cell-text">{{bp.header.nummer}}</wd-comment-indicator></td>
			<th>Kartierer</th>
			<td><wd-comment-indicator [fields]="['Kartierer']" class="cell-text">{{canSeePersonalData() ? bp.header.aufnahme.kartierer : '–'}}</wd-comment-indicator></td>
		</tr>
		<tr bpHl="Aufnahme" [hldata]="bp" class="lborder rborder">
			<th>Labornummer</th>
			<td><wd-comment-indicator [fields]="['Labornummer', 'Status Laboranalyse']" class="cell-text">{{bp.header.labornummer}} <span class="status-text">{{bp.header.statusLaboranalyse}}</span></wd-comment-indicator></td>
			<ng-container *ngIf="!printView">
			<th>Projekt</th>
			<td><span class="cell-text">{{ projekteString() }}</span></td>
		</ng-container>
		<ng-container *ngIf="printView">
			<th></th><td></td>
		</ng-container>
		</tr>
		<tr bpHl="Aufnahme" [hldata]="bp" class="bborder lborder rborder">
			<th></th>
			<td></td>
			<th></th>
			<td></td>
		</tr>
		<tr class="spacer-row"><td colspan="4"></td></tr>
		<tr bpHl="Adresse" [hldata]="bp" class="tborder lborder rborder">
			<th>Forstamt</th>
			<td><wd-comment-indicator [fields]="['Forstamt']" class="cell-text">{{bp.header.forstamt}}</wd-comment-indicator></td>
			<th>Revier</th>
			<td><wd-comment-indicator [fields]="['Revier']" class="cell-text">{{bp.header.revier}}</wd-comment-indicator></td>
		</tr>
		<tr bpHl="Adresse" [hldata]="bp" class="lborder rborder">
			<th>Forstbetrieb</th>
			<td><wd-comment-indicator [fields]="['Forstbetrieb']" class="cell-text">{{bp.header.forstbetrieb}}</wd-comment-indicator></td>
			<th>Abt./UA/TF</th>
			<td><wd-comment-indicator [fields]="['Abteilung', 'Unterabteilung', 'Teilfläche']" class="cell-text">{{adresse()}}</wd-comment-indicator></td>
		</tr>
		<tr bpHl="Adresse" [hldata]="bp" class="bborder lborder rborder">
			<th>Gem./Flur/FS</th>
			<td><wd-comment-indicator [fields]="['Gemarkung', 'Flur', 'Flurstück']" class="cell-text">{{gemarkungFlurFS()}}</wd-comment-indicator></td>
			<th></th>
			<td></td>
		</tr>
		<tr class="spacer-row"><td colspan="4"></td></tr>
		<tr bpHl="Naturraum" [hldata]="bp" class="tborder lborder rborder">
			<th>Wuchsgebiet</th>
			<td><wd-comment-indicator [fields]="['Wuchsgebiet']" class="cell-text">{{bp.extendedHeader.wuchsgebiet}}</wd-comment-indicator></td>
			<th>Wuchsbezirk</th>
			<td><wd-comment-indicator [fields]="['Wuchsbezirk']" class="cell-text">{{bp.extendedHeader.wuchsbezirk}}</wd-comment-indicator></td>
		</tr>
		<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
			<th>Geologie</th>
			<td><wd-comment-indicator [fields]="['GeologieOben', 'GeologieUnten']" class="cell-text">{{geologieDisplay()}}</wd-comment-indicator></td>
			<th>Klimastufe</th>
			<td><wd-comment-indicator [fields]="['KlimastufeNeu', 'KlimastufeAlt']" class="cell-text">{{klimastufeDisplay()}}</wd-comment-indicator></td>
		</tr>
		<tr *ngIf="isM()" bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
			<th style="white-space: nowrap">Moortyp (ökol.)</th>
			<td><wd-comment-indicator [fields]="['Ökologischer Moortyp']" class="cell-text">{{bp.extendedHeader.moorTyp?.oekologisch}}</wd-comment-indicator></td>
			<th>Moortyp (hydr.)</th>
			<td><wd-comment-indicator [fields]="['Hydrogenetischer Moortyp']" class="cell-text">{{bp.extendedHeader.moorTyp?.hydrogenetisch}}</wd-comment-indicator></td>
		</tr>
		<!-- Relief-Anzeige -->
		@if (!isM()) {
			<!-- B- und G-Punkte: Zusammengefasste Relief-Anzeige -->
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Relief</th>
				<td><wd-comment-indicator [fields]="['Neigungsstufe', 'NeigungGrad', 'Woelbung', 'Hangrichtung', 'ReliefformUmgebung', 'Hanganschluss', 'Hangteil', 'Hoehenspanne', 'InnereRauhheit', 'Reliefform']" class="cell-text">{{reliefBeschreibung()}}</wd-comment-indicator></td>
				<th>Mesoklima</th>
				<td><wd-comment-indicator [fields]="['Mesoklima']" class="cell-text">{{bp.extendedHeader.mesoklima}}</wd-comment-indicator></td>
			</tr>
		} @else {
			<!-- M-Punkte: Moor-Relief -->
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Relief</th>
				<td><wd-comment-indicator [fields]="['Reliefform Bestand', 'Reliefform Bodenvegetation']" class="cell-text">{{reliefMoorDisplay()}}</wd-comment-indicator></td>
				<th>Mesoklima</th>
				<td><wd-comment-indicator [fields]="['Mesoklima']" class="cell-text">{{bp.extendedHeader.mesoklima}}</wd-comment-indicator></td>
			</tr>
		}
		<tr *ngIf="!isM()" bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
			<th>Morphologie</th>
			<td><wd-comment-indicator [fields]="['Morphologie*']" class="cell-text">{{morphologieDisplay()}}</wd-comment-indicator></td>
			<th>KMgCaP</th>
			<td><wd-comment-indicator [fields]="['KMgCaP-Serie']" class="cell-text">{{bp.extendedHeader.kMgCaPSerie}}</wd-comment-indicator></td>
		</tr>
		<tr bpHl="Naturraum" [hldata]="bp" class="bborder lborder rborder">
			<th>Witterung</th>
			<td><wd-comment-indicator [fields]="['Witterung']" class="cell-text">{{bp.extendedHeader.witterung}}</wd-comment-indicator></td>
			<th></th>
			<td></td>
		</tr>
		<!-- Grube-spezifische Summary-Zeilen (Punktart 1-4) -->
		@if (isG()) {
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Klimabereich</th>
				<td><wd-comment-indicator [fields]="['Klimabereich']" class="cell-text">{{altNeuDisplay(bp.extendedHeader.klimabereich)}}</wd-comment-indicator></td>
				<th>Meereshöhe</th>
				<td><wd-comment-indicator [fields]="['Meereshoehe']" class="cell-text">{{bp.extendedHeader.meereshoehe}}</wd-comment-indicator></td>
			</tr>
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Grundgestein/Sed.</th>
				<td><wd-comment-indicator [fields]="['GrundgesteinSediment']" class="cell-text">{{bp.extendedHeader.grundgesteinSediment}}</wd-comment-indicator></td>
				<th>Lage</th>
				<td><wd-comment-indicator [fields]="['LageGrube']" class="cell-text">{{bp.extendedHeader.lage}}</wd-comment-indicator></td>
			</tr>
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Mosaikbereich</th>
				<td><wd-comment-indicator [fields]="['MosaikNummer', 'MosaikName', 'MosaikHaupttyp']" class="cell-text">{{mosaikDisplay()}}</wd-comment-indicator></td>
				<th>Mesorelief</th>
				<td><wd-comment-indicator [fields]="['Mesorelief']" class="cell-text">{{bp.extendedHeader.mesorelief}}</wd-comment-indicator></td>
			</tr>
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Humusform Gesamt</th>
				<td><wd-comment-indicator [fields]="['HumusformGesamt']" class="cell-text">{{altNeuDisplay(bp.header.humusform.gesamtFlaeche)}}</wd-comment-indicator></td>
				<th>Humusform morph.</th>
				<td><wd-comment-indicator [fields]="['HumusformMorphologisch']" class="cell-text">{{altNeuDisplay(bp.header.humusform.morphologisch)}}</wd-comment-indicator></td>
			</tr>
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Bestockungstyp</th>
				<td><wd-comment-indicator [fields]="['Bestockungstyp']" class="cell-text">{{altNeuDisplay(bp.extendedHeader.bestockungsTyp)}}</wd-comment-indicator></td>
				<th>STFG Zustand</th>
				<td><wd-comment-indicator [fields]="['ZustandsSTFG']" class="cell-text">{{altNeuDisplay(bp.extendedHeader.stfg.zustands)}}</wd-comment-indicator></td>
			</tr>
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Begründungsart</th>
				<td><wd-comment-indicator [fields]="['Begründungsart']" class="cell-text">{{bp.extendedHeader.begruendungsart}}</wd-comment-indicator></td>
				<th>Mischform</th>
				<td><wd-comment-indicator [fields]="['Mischform']" class="cell-text">{{bp.extendedHeader.mischform}}</wd-comment-indicator></td>
			</tr>
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Waldfunktion</th>
				<td colspan="3"><wd-comment-indicator [fields]="['Waldfunktion']" class="cell-text">{{bp.extendedHeader.waldfunktion}}</wd-comment-indicator></td>
			</tr>
			<tr bpHl="Baumarten" [hldata]="bp" class="lborder rborder">
				<th>Probestämme</th>
				<td colspan="3"><wd-comment-indicator [fields]="['BaumartArt']" class="cell-text">{{baumarten()}}</wd-comment-indicator></td>
			</tr>
		}
		<tr class="spacer-row"><td colspan="4"></td></tr>
		<tr bpHl="Bestand" [hldata]="bp" class="lborder rborder tborder">
			<th>Bestand</th>
			<td colspan="3"><wd-comment-indicator [fields]="['Bestand']" class="cell-text">{{baumarten()}}</wd-comment-indicator></td>
		</tr>
		<!-- Bemerkungen teilt sich die hl-area mit Bestand (bpHl="Bestand"): beide Zeilen
		     bilden eine Klick-/Hervorhebungs-Gruppe und oeffnen denselben kombinierten
		     Editor „Bestand & Bemerkungen".
		     Mehrzeilen-Feld wie im Reiter „Boden": Nackter Text in der Zelle verlor die
		     getippten Zeilenumbrueche (Nutzer-Befund 24.09.2026). Kommentare zeigt das
		     Feld ueber seinen Namen selbst an, ein Kommentar-Indikator ist nicht noetig. -->
		<tr bpHl="Bestand" [hldata]="bp" class="lborder rborder bborder">
			<th>Bemerkungen</th>
			<td colspan="3"><wd-multiline-text name="Bemerkungen" [model]="bp.header.bemerkungen"></wd-multiline-text></td>
		</tr>
	</tbody>
</table>
</div>
